import { AiOutlineSmile } from "react-icons/ai";
import { FaAward } from "react-icons/fa";
import { GiFiles } from "react-icons/gi";

const aboutData = [
  {
    id: 1,
    icon: <FaAward />,
    title: "Learning Journey",
    desc: "Progression",
  },
  {
    id: 2,
    icon: <GiFiles />,
    title: "Personal Projects",
    desc: "Creation",
  },
  {
    id: 3,
    icon: <AiOutlineSmile />,
    title: "Community Engagement",
    desc: "Collaboration",
  },
];

export default aboutData;
